/*eslint-disable*/
import Api from './';

class Connection {
    static tryToConnect () {
        return Api.axios.get('/try-to-connect')
            .then(response => response);
    }
}

export default Connection;